import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BrowserPlatformService } from '../../shared/services/browser-platform.service';

type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly browser = inject(BrowserPlatformService);
  private themeSubject = new BehaviorSubject<Theme>('light');
  theme$ = this.themeSubject.asObservable();

  constructor() {
    const savedTheme = this.toTheme(this.browser.getLocalStorageItem('theme'));
    this.setTheme(savedTheme);
  }

  toggleTheme() {
    const newTheme = this.themeSubject.value === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }

  setTheme(theme: Theme) {
    this.themeSubject.next(theme);
    this.browser.setLocalStorageItem('theme', theme);

    const browserDocument = this.browser.document;
    if (!browserDocument) return;

    if (theme === 'dark') {
      browserDocument.documentElement.classList.add('dark');
      browserDocument.body.classList.add('dark:bg-gray-900');
    } else {
      browserDocument.documentElement.classList.remove('dark');
      browserDocument.body.classList.remove('dark:bg-gray-900');
    }
  }

  private toTheme(value: string | null): Theme {
    return value === 'dark' ? 'dark' : 'light';
  }
}
